import { get } from "../../service/api";

const getPaidMerchantInvoices = async (merchantId) => {
  try {
    const response = await get(`/merchant/${merchantId}/paidMerchantInvoices`);
    return response.data;
  } catch (error) {
    console.error("Error getPaidMerchantInvoices:", error);
    throw error;
  }
};

export default getPaidMerchantInvoices;
